import { alertClasses } from '@mui/material/Alert'
import { CssVarsThemeOptions, alpha } from '@mui/material/styles'

// ----------------------------------------------------------------------

const COLORS = ['info', 'success', 'warning', 'error'] as const

// ----------------------------------------------------------------------

export function alertOverrides(): CssVarsThemeOptions['components'] {
	return {
		MuiAlert: {
			styleOverrides: {
				root: ({ theme, ownerState }) => {
					const standardVariant = ownerState.variant === 'standard'

					const filledVariant = ownerState.variant === 'filled'

					const outlinedVariant = ownerState.variant === 'outlined'

					const colorStyle = COLORS.map((color) => ({
						...(ownerState.severity === color && {
							// STANDARD
							...(standardVariant && {
								color: theme.vars.palette[color].contrastText,
								backgroundColor: theme.vars.palette[color].light,
								[`& .${alertClasses.icon}`]: {
									color: theme.vars.palette[color].main,
								},
							}),
							// FILLED
							...(filledVariant && {
								color: theme.vars.palette[color].contrastText,
								backgroundColor: theme.vars.palette[color].main,
							}),
							// OUTLINED
							...(outlinedVariant && {
								backgroundColor: `rgba(${theme.vars.palette[color].mainChannel} / 0.08)`,
								color: theme.palette[color]['dark'],
								border: `solid 1px ${alpha(theme.palette[color].main, 0.16)}`,
								[`& .${alertClasses.icon}`]: {
									color: theme.palette[color].main,
								},
							}),
						}),
					}))

					return [...colorStyle]
				},
				icon: {
					opacity: 1,
				},
			},
		},
		MuiAlertTitle: {
			styleOverrides: {
				root: ({ theme }) => ({
					marginBottom: theme.spacing(0.5),
					fontWeight: theme.typography.fontWeightMedium,
				}),
			},
		},
	}
}
